import * as React from "react";
import classnames from "classnames";
/* empty css               */
const ImageZoom = ({ children, onZoom }) => {
  const ref = React.useRef(null);
  const [zooming, setZooming] = React.useState(false);
  const handleMouseMove = (e) => {
    if (e.target instanceof Element) {
      const { left, top, width, height } = e.target.getBoundingClientRect();
      const x = Math.round((e.clientX - left) / width * 100);
      const y = Math.round((e.clientY - top) / height * 100);
      if (ref.current) {
        ref.current.style.transformOrigin = `${x}% ${y}%`;
      }
    }
  };
  const resetZoom = () => {
    setZooming(false);
    if (ref.current) {
      ref.current.style.transformOrigin = `0% 0%`;
    }
  };
  const enableZoom = () => {
    setZooming(true);
    onZoom();
  };
  const transformOrigin = ref?.current?.style.transformOrigin || "0% 0%";
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      onMouseEnter: enableZoom,
      onMouseLeave: resetZoom,
      onMouseMove: handleMouseMove,
      className: classnames("image-zoom", { "image-zoom--hover": zooming }),
      "data-t": "image-zoom"
    },
    /* @__PURE__ */ React.createElement("div", { className: "image-zoom__img", "data-t": "zoom__image", style: { transformOrigin }, ref }, children)
  );
};
export {
  ImageZoom
};
//# sourceMappingURL=ImageZoom.js.map
